<template>
  <vue-modal classes="vue-modal-container"
             height="auto"
             name="aszf-modal"
             scrollable
             width="80%">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('aszf-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <h3>{{ trans.subHeader }}</h3>
      <p>{{ trans.p1 }}</p>
      <p>{{ trans.p2 }}</p>
      <p>{{ trans.p3 }}</p>
      <p>{{ trans.p4 }}</p>
      <p>{{ trans.p5 }}</p>
      <h3>{{ trans.subHeader2 }}</h3>
      <p>{{ trans.p_2_1 }}<br>
        {{ trans.p_2_2 }}<br>
        {{ trans.p_2_3 }}<br>
        {{ trans.p_2_4 }}</p>
      <h3>{{ trans.subHeader3 }}</h3>
      <ol>
        <li>{{ trans.p_3_1 }}</li>
        <li>{{ trans.p_3_2 }}</li>
        <li>{{ trans.p_3_3 }}</li>
        <li>{{ trans.p_3_4 }}</li>
        <li>{{ trans.p_3_5 }}</li>
        <li>{{ trans.p_3_6 }}</li>
        <li>{{ trans.p_3_7 }}</li>
      </ol>
      <h3>{{ trans.subHeader4 }}</h3>
      <h5>{{ trans.subHeader5 }}</h5>
      <ol type="a">
        <li>{{ trans.p_4_1 }}</li>
        <li>{{ trans.p_4_2 }}</li>
        <li>{{ trans.p_4_3 }}</li>
        <li>{{ trans.p_4_4 }}</li>
        <li>{{ trans.p_4_5 }}</li>
        <li>{{ trans.p_4_6 }}</li>
      </ol>
      <p>{{ trans.p_5_1 }}</p>
      <h3>{{ trans.subHeader6 }}</h3>
      <h5>{{ trans.subHeader7 }}</h5>
      <ol>
        <li>{{ trans.p_6_1 }}
          <div>
            <table class="ui celled table">
              <thead>
              <tr>
                <th>{{ trans.p_6_2 }}</th>
                <th>{{ trans.p_6_3 }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ trans.p_6_3 }}</td>
                <td>{{ trans.p_6_4 }}</td>
              </tr>
              <tr>
                <td>{{ trans.p_6_5 }}</td>
                <td>{{ trans.p_6_6 }}</td>
              </tr>
              <tr>
                <td>{{ trans.p_6_8 }}</td>
                <td>{{ trans.p_6_9 }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>{{ trans.p_6_10 }}</li>
        <li>{{ trans.p_6_11 }}</li>
        <li>{{ trans.p_6_12 }}</li>
        <li>
          <h5>{{ trans.subHeader8 }}</h5>
          <ul>
            <li>{{ trans.p_7_1 }}</li>
            <li>{{ trans.p_7_2 }}</li>
            <li>{{ trans.p_7_3 }}</li>
          </ul>
        </li>
        <li>
          {{ trans.p_7_4 }}
          <ul>
            <li>{{ trans.p_7_5 }}</li>
            <li>{{ trans.p_7_6 }}</li>
            <li>{{ trans.p_7_7 }}</li>
          </ul>
        </li>
        <li>{{ trans.p_7_8 }}</li>
        <li>
          {{ trans.p_7_9 }}
          <ul>
            <li><strong>{{ trans.p_7_10 }}</strong> {{ trans.p_7_11 }}</li>
            <li><strong>{{ trans.p_7_12 }}</strong> {{ trans.p_7_13 }}</li>
            <li>{{ trans.p_7_14 }}<strong>{{ trans.p_7_15 }}</strong> {{ trans.p_7_16 }}</li>
          </ul>
        </li>
      </ol>
      <div><span v-html="trans.list1"></span></div>
      <div><span v-html="trans.list2"></span></div>
      <div><span v-html="trans.list3"></span></div>
    </div>
  </vue-modal>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      trans: state => state.trans.aszfModal,
    }),
  },
  mounted: function () {
    let query = this.$route.query
    if (query?.isShowAszf) {
      // eslint-disable-next-line
      this.$modal.show('aszf-modal')
    }
  },
}
</script>

<style scoped>

</style>
